/**
 * Application Configuration
 * Centralized configuration for the frontend application
 */

// API Configuration - Auto-detect environment
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
export const API_URL = import.meta.env.VITE_API_URL ||
    (isProduction ? 'https://hipoteca-espana-production.up.railway.app/api' : 'http://localhost:3000/api');

// Firebase Configuration
export const firebaseConfig = {
    apiKey: "AIzaSyBFiGMUNNZdzcgDlmVNiGGKS23wgcjmSI4",
    authDomain: "hipotecafacil-e94b9.firebaseapp.com",
    projectId: "hipotecafacil-e94b9",
    storageBucket: "hipotecafacil-e94b9.firebasestorage.app",
    messagingSenderId: "422935583196",
    appId: "1:422935583196:web:4194d10a77d09fa14cd719",
    measurementId: "G-LHZDN83TMC"
};

// App Configuration
export const APP_CONFIG = {
    name: 'Jóvenes Independientes',
    version: '1.0.0'
};

// Stripe Configuration (templates only - app is free)
export const STRIPE_CONFIG = {
    publishableKey: 'pk_test_51PRWy5Co3bBMRMzGXw0GMpPUhKWYbH18hoN6t1h8nXGE55fGFR89h3cYwsnzHvBVpQu99546GrXBHAfrcEeKgXcP00tBByHXBz',
    prices: {
        // Templates
        templateHipoteca: 'price_1SnjVZCo3bBMRMzGU9rwYjUM',
        templateGastos: 'price_1SnjVxCo3bBMRMzGC0Sf6WA4',
        templateAhorro: 'price_1SnjWJCo3bBMRMzG8U0aIBss',
        templateComparador: 'price_1SnjWdCo3bBMRMzGJv42mqHn',
        templatePack: 'price_1SnjWvCo3bBMRMzGDwCDSB6C'
    }
};

